import { __ } from '@wordpress/i18n'

import React from 'react'
import PropTypes from 'prop-types'
import {
  Teaser,
  Image,
  Content,
  Title,
  DateBadge,
  Link,
  ReadMore,
  Description,
} from './custom.styled'

const InsightTeaser = ({ post, isSlider = false, isEditor = false }) => {
  return (
    post && (
      <Teaser isSlider={isSlider}>
        {post.image.url && (
          <Image
            src={post.image.url}
            alt={post.image.alt || post.image.title}
          />
        )}
        <Content>
          <DateBadge>
            <i className="las la-calendar"></i>
            <span>{post.date}</span>
          </DateBadge>
          <Description
            dangerouslySetInnerHTML={{ __html: post.description_insights }}
          ></Description>
          <Title>{post.title}</Title>
        </Content>
        {!isEditor && <Link href={post.link.url}></Link>}
        <ReadMore>
          {__('Read More', 'dhsv_theme')}
          <i className="las la-arrow-circle-right"></i>
        </ReadMore>
      </Teaser>
    )
  )
}

InsightTeaser.propTypes = {
  post: PropTypes.object,
  isSlider: PropTypes.bool,
  isEditor: PropTypes.bool,
}

export default InsightTeaser
